export enum ResponseStatus {
  Error = 'error',
  Info = 'info',
  Success = 'success',
  Warning = 'warning',
}
